import { ListItem } from "arkh";
import { WorkspaceTodoItemRowContainer } from "./WorkspaceTodoItemRowContainer";
import { SortableColumnTitle } from "../SortableColumnTitle";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";

export type WorkspaceTodoSortKey =
  | "priority"
  | "description"
  | "filter"
  | "published"
  | "deadline"
  | "status"
  | "topic";

type WorkspaceTodoOrder = {
  column: WorkspaceTodoSortKey;
  order: "ASC" | "DESC";
};
export function WorkspaceTodoHeader(props: {
  onOrderChange: (newOrder: WorkspaceTodoOrder) => void;
  order: WorkspaceTodoOrder;
  showTopics: boolean;
}) {
  const order = props.order;

  const propsForColumn = (column: WorkspaceTodoSortKey) => {
    return {
      order: order.column === column ? order.order : null,
      onOrderChange: () => {
        props.onOrderChange({
          column,
          order: order.order === "ASC" ? "DESC" : "ASC",
        });
      },
      onOrderBySelect: () => {
        props.onOrderChange({
          column,
          order: "DESC",
        });
      },
    };
  };

  const intl_tokens = useIntlTokens();

  return (
    <ListItem disabled border="border-primary" displayMode="TABLE">
      <WorkspaceTodoItemRowContainer
        priority={
          <SortableColumnTitle
            title={intl_tokens.Prio}
            {...propsForColumn("priority")}
          />
        }
        description={
          <SortableColumnTitle
            title={intl_tokens.Description}
            {...propsForColumn("description")}
          />
        }
        published={
          <SortableColumnTitle
            title={intl_tokens.Published}
            {...propsForColumn("published")}
          />
        }
        deadline={
          <SortableColumnTitle
            title={intl_tokens.Deadline}
            {...propsForColumn("deadline")}
          />
        }
        status={
          <SortableColumnTitle
            title={intl_tokens.Status}
            {...propsForColumn("status")}
          />
        }
        topic={
          props.showTopics ? (
            <SortableColumnTitle
              title={intl_tokens.Topic}
              {...propsForColumn("topic")}
            />
          ) : null
        }
        more={null}
      />
    </ListItem>
  );
}
